<template>
  <div v-if="snackbar" class="tw:toast tw:toast-end tw:z-2000">
    <div class="tw:alert tw:bg-primary tw:text-white">
      An update is available. Please save your work and refresh.
      <app-button @click="refresh" class="tw:text-xs">Refresh</app-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import AppButton from '@/components/v2/AppButton.vue';

export default {
  name: 'VersionNotifier',
  components: { AppButton },
  data: () => ({
    interval: import.meta.env.VITE_VERSION_NOTIFIER_INTERVAL || 5000,
    snackbar: false,
    timeout: -1,
    runningVersion: '',
    intervalId: 0
  }),
  methods: {
    refresh() {
      window.location.reload();
    },
    async getVersion() {
      const url = import.meta.env.BASE_URL || '';
      const response = await axios.get(url, {headers: {'Accept': 'text/html'}});
        return response.data;
    },
    async versionInterval() {
      if (this.interval < 0) return;

      this.intervalId = window.setInterval(async function() {
        if (this.runningVersion !== await this.getVersion()) {
          this.snackbar = true;
        }
      }.bind(this),this.interval);
    }
  },
  async created() {
    this.runningVersion = await this.getVersion();
  },
  async mounted() {
    await this.versionInterval();
  },
  async unmounted() {
    clearInterval(this.intervalId);
  }
};
</script>
